function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12{fill:#ffe600;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#646464;}.cls-3{fill:#080607;}.cls-4{fill:#0e0708;}.cls-5{fill:#43444e;}.cls-6{fill:#fcddb9;}.cls-7{fill:#f9d2a5;}.cls-8{fill:#feead2;}.cls-9{fill:#e2c703;}.cls-10{fill:#4d4e59;}.cls-11{fill:#fef2e3;}.cls-13{fill:#ea5162;}.cls-14{fill:#150201;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_2",
  "data-name": "Capa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Capa_1-2",
  "data-name": "Capa 1"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "0 72.66 187.96 72.66 200.18 86.08 187.96 99.5 0 99.5 12.22 86.08 0 72.66"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "187.96 72.66 375.91 72.66 388.13 86.08 375.91 99.5 187.96 99.5 200.18 86.08 187.96 72.66"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "375.91 72.66 563.87 72.66 576.09 86.08 563.87 99.5 375.91 99.5 388.13 86.08 375.91 72.66"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "563.87 72.66 751.82 72.66 764.04 86.08 751.82 99.5 563.87 99.5 576.09 86.08 563.87 72.66"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "751.82 72.66 939.78 72.66 952 86.08 939.78 99.5 751.82 99.5 764.04 86.08 751.82 72.66"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "184.08 77.55 191.84 86.08 184.08 94.61 184.08 77.55"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M169.58,77.55l7.76,8.53-7.76,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M155.08,77.55l7.76,8.53-7.76,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M140.58,77.55l7.76,8.53-7.76,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M126.08,77.55l7.77,8.53-7.77,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M111.58,77.55l7.76,8.53-7.76,8.53Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "97.08 77.55 104.84 86.08 97.08 94.61 97.08 77.55"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "372.03 77.55 379.8 86.08 372.03 94.61 372.03 77.55"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M357.53,77.55l7.77,8.53-7.77,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M343,77.55l7.77,8.53L343,94.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M328.53,77.55l7.77,8.53-7.77,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M314,77.55l7.77,8.53L314,94.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M299.53,77.55l7.77,8.53-7.77,8.53Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "285.03 77.55 292.8 86.08 285.03 94.61 285.03 77.55"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "559.99 77.55 567.76 86.08 559.99 94.61 559.99 77.55"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M545.49,77.55l7.77,8.53-7.77,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M531,77.55l7.77,8.53L531,94.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M516.49,77.55l7.77,8.53-7.77,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M502,77.55l7.77,8.53L502,94.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M487.49,77.55l7.77,8.53-7.77,8.53Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "472.99 77.55 480.76 86.08 472.99 94.61 472.99 77.55"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "747.95 77.55 755.71 86.08 747.95 94.61 747.95 77.55"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M733.45,77.55l7.76,8.53-7.76,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M719,77.55l7.76,8.53L719,94.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M704.45,77.55l7.76,8.53-7.76,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M690,77.55l7.76,8.53L690,94.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M675.45,77.55l7.76,8.53-7.76,8.53Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "660.95 77.55 668.71 86.08 660.95 94.61 660.95 77.55"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "935.9 77.55 943.67 86.08 935.9 94.61 935.9 77.55"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M921.4,77.55l7.77,8.53-7.77,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M906.9,77.55l7.77,8.53-7.77,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M892.4,77.55l7.77,8.53-7.77,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M877.9,77.55l7.77,8.53-7.77,8.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M863.4,77.55l7.77,8.53-7.77,8.53Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "848.9 77.55 856.67 86.08 848.9 94.61 848.9 77.55"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M398.1,99.38a3,3,0,0,1-1-2.53c.06-3.1,0-6.21,0-9.31A17.14,17.14,0,0,1,411.75,71c1.22-.17,2.44-.07,3.66-.3a7,7,0,0,0,5.77-6.58.83.83,0,0,0-.54-.88A22,22,0,0,1,408.9,47.46a13.69,13.69,0,0,1-.29-2.39c0-.56-.21-.75-.71-.93a6.73,6.73,0,0,1-4.55-6.52c0-3.36-.1-6.73,0-10.08.29-7.64,2.4-14.62,7.93-20.19A24.63,24.63,0,0,1,425.45.41,37.44,37.44,0,0,1,447,3.7c1.35.62,1.62,1.24,1.08,2.61-.24.6.2.45.45.53a22.65,22.65,0,0,1,10.74,6.75,21.65,21.65,0,0,1,2.2,2.94,1.76,1.76,0,0,1-.22,2.46,11.26,11.26,0,0,0-3,8.21c0,3.33,0,6.66,0,10,0,1.66-.36,2.08-2,2.33a2.07,2.07,0,0,1-1.31-2.23c.05-3.3.09-6.59,0-9.89A14.28,14.28,0,0,1,457.73,18c.29-.38.25-.61,0-1a18.75,18.75,0,0,0-8.83-6.49,34.06,34.06,0,0,0-7.08-1.35c-1.61-.23-2.08-1-1.6-2.54.4-.69,1.23-.75,1.92-1.23-.32-.12-.53-.22-.76-.29-5.35-1.61-10.76-2.36-16.3-1.2C416.21,5.75,410.5,11,408,19.7c-1.7,5.86-1.3,11.9-1.28,17.89a3,3,0,0,0,1.87,3.09c0-3.65,0-7.2,0-10.75a11.55,11.55,0,0,1,.63-3.7,12.62,12.62,0,0,1,5-6.21c2.8-1.52,5.83-1.62,8.92-1.58,6,.07,12,.06,17.94,0a11.71,11.71,0,0,1,11.76,11.68c-.08,3.75,0,7.5,0,11.25,0,.42.06.83.08,1.25a28.21,28.21,0,0,1-.77,6.6A22.2,22.2,0,0,1,439.23,64l-.6.29a23.22,23.22,0,0,1-12.47,1c-1.68-.35-1.68-.32-2,1.32a2.47,2.47,0,0,1-.19.54c-.55.88-.16,1.31.66,1.74a12.71,12.71,0,0,0,8.29,1.3,1.9,1.9,0,0,1,2.4,1.08c0,1.5-.33,1.9-1.82,2.21a16,16,0,0,1-8.08-.59,17,17,0,0,1-3.11-1.54.71.71,0,0,0-1.07.11A10.28,10.28,0,0,1,416,74c-1.24.23-2.5.14-3.76.28-5.84.67-11.18,6.15-11.62,12-.28,3.84-.09,7.69-.11,11.53,0,.72-.56,1.1-1,1.52Zm28.25-37.6a9.47,9.47,0,0,0,2.74.5,18.83,18.83,0,0,0,20.42-18.83q0-6.56,0-13.1a8.24,8.24,0,0,0-8.37-8.53c-6.95-.05-13.9,0-20.85,0a7.56,7.56,0,0,0-4.94,1.61A7.72,7.72,0,0,0,411.89,30c-.06,4.52,0,9,0,13.56a18.15,18.15,0,0,0,3.33,10.62A18,18,0,0,0,426.35,61.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M439.06,66.84a2,2,0,0,1,2.38,1,6.54,6.54,0,0,0,5.73,3A17.13,17.13,0,0,1,464,85a20.77,20.77,0,0,1,.27,3.86c0,2.68-.05,5.36,0,8a2.94,2.94,0,0,1-1,2.53h-1.36a2.27,2.27,0,0,1-1.06-1.58c0-3.36.08-6.71,0-10.07a13.71,13.71,0,0,0-13.6-13.55,10.38,10.38,0,0,1-8.75-4.63C437.89,68.22,438,67.83,439.06,66.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M452.9,42.63c0-.42-.08-.83-.08-1.25,0-3.75-.07-7.5,0-11.25a11.71,11.71,0,0,0-11.76-11.68c-6,.05-12,.06-17.94,0-3.09,0-6.12.06-8.92,1.58a1.52,1.52,0,0,1,.2-.83A21,21,0,0,1,418,14c4.85-5.14,11-7.3,17.92-7.54a20.77,20.77,0,0,1,4.24.18c-.48,1.57,0,2.31,1.6,2.54a34.06,34.06,0,0,1,7.08,1.35A18.75,18.75,0,0,1,457.7,17c.28.38.32.61,0,1a14.28,14.28,0,0,0-2.82,9.42c.1,3.3.06,6.59,0,9.89a2.07,2.07,0,0,0,1.31,2.23A4.68,4.68,0,0,1,452.9,42.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M439.06,66.84c-1.09,1-1.17,1.38-.53,2.71l-1.44,1-.19.14h0l-1.55.55a1.9,1.9,0,0,0-2.4-1.08,12.71,12.71,0,0,1-8.29-1.3c-.82-.43-1.21-.86-.66-1.74a2.47,2.47,0,0,0,.19-.54,23.81,23.81,0,0,0,5.37,1A23.18,23.18,0,0,0,438.81,66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M438.81,66a23.18,23.18,0,0,1-9.25,1.57,23.81,23.81,0,0,1-5.37-1c.29-1.64.29-1.67,2-1.32a23.22,23.22,0,0,0,12.47-1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M415.35,23.43a7.56,7.56,0,0,1,4.94-1.61c6.95,0,13.9-.05,20.85,0a8.24,8.24,0,0,1,8.37,8.53q0,6.56,0,13.1a18.83,18.83,0,0,1-20.42,18.83,9.47,9.47,0,0,1-2.74-.5,1,1,0,0,0,.58-.31,3.19,3.19,0,0,0-.64-4.55,23,23,0,0,1-4.88-4.18,20.45,20.45,0,0,1-3.57-5.81,25.77,25.77,0,0,1-1.49-9.56c0-3.23,0-6.46,0-9.69,0-1.43.28-2.93-1-4.06C415.34,23.58,415.35,23.49,415.35,23.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M435.35,71.2l1.55-.55a10.94,10.94,0,0,0-1,2.69c-.13,2.47,1.95,4.46,4.76,4.5A15.94,15.94,0,0,1,450.54,81a15,15,0,0,1,6.2,11.6c.09,1.69-.35,3.69,1.49,4.91,0,0,0,.13,0,.19-.35,0-.71.09-1.06.09H403.75c-.32,0-.64,0-1-.05a3.86,3.86,0,0,0,1.85-2.56,14.93,14.93,0,0,0,.06-2.22,14.4,14.4,0,0,1,4.24-10.27,15.42,15.42,0,0,1,11.53-4.79c2.63,0,5.4-1.82,5-5.05a16,16,0,0,0,8.08.59C435,73.1,435.35,72.7,435.35,71.2Zm9.55,23h2.61a1.62,1.62,0,0,0,1.61-1.59,1.64,1.64,0,0,0-1.52-1.7c-1.74-.07-3.48-.07-5.21,0a1.68,1.68,0,0,0-1.58,1.66,1.65,1.65,0,0,0,1.68,1.64C443.29,94.22,444.1,94.19,444.9,94.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M440.19,6.61A20.77,20.77,0,0,0,436,6.43C429,6.67,422.88,8.83,418,14a21,21,0,0,0-3.62,5.22,1.52,1.52,0,0,0-.2.83,12.62,12.62,0,0,0-5,6.21,11.55,11.55,0,0,0-.63,3.7c0,3.55,0,7.1,0,10.75a3,3,0,0,1-1.87-3.09c0-6-.42-12,1.28-17.89C410.5,11,416.21,5.75,425.05,3.89c5.54-1.16,10.95-.41,16.3,1.2.23.07.44.17.76.29C441.42,5.86,440.59,5.92,440.19,6.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M415.35,23.43c0,.06,0,.15,0,.19,1.24,1.13.95,2.63,1,4.06,0,3.23,0,6.46,0,9.69a25.77,25.77,0,0,0,1.49,9.56,20.45,20.45,0,0,0,3.57,5.81,23,23,0,0,0,4.88,4.18,3.19,3.19,0,0,1,.64,4.55,1,1,0,0,1-.58.31,18,18,0,0,1-11.14-7.6,18.15,18.15,0,0,1-3.33-10.62c0-4.52-.05-9,0-13.56A7.72,7.72,0,0,1,415.35,23.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M425.45,72.82c.41,3.23-2.36,5.05-5,5.05a15.42,15.42,0,0,0-11.53,4.79,14.4,14.4,0,0,0-4.24,10.27,14.93,14.93,0,0,1-.06,2.22,3.86,3.86,0,0,1-1.85,2.56l-2.28.15c0-3.84-.17-7.69.11-11.53.44-5.87,5.78-11.35,11.62-12,1.26-.14,2.52,0,3.76-.28a10.28,10.28,0,0,0,5.28-2.64.71.71,0,0,1,1.07-.11A17,17,0,0,0,425.45,72.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M458.25,97.67c0-.06,0-.16,0-.19-1.84-1.22-1.4-3.22-1.49-4.91a15,15,0,0,0-6.2-11.6,15.94,15.94,0,0,0-9.85-3.13c-2.81,0-4.89-2-4.76-4.5a10.94,10.94,0,0,1,1-2.69h0l.19-.14,1.44-1a10.38,10.38,0,0,0,8.75,4.63,13.71,13.71,0,0,1,13.6,13.55c.07,3.36,0,6.71,0,10.07A15.29,15.29,0,0,1,458.25,97.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M437.09,70.51l-.19.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M444.9,94.19c-.8,0-1.61,0-2.41,0a1.65,1.65,0,0,1-1.68-1.64,1.68,1.68,0,0,1,1.58-1.66c1.73-.06,3.47-.06,5.21,0a1.64,1.64,0,0,1,1.52,1.7,1.62,1.62,0,0,1-1.61,1.59H444.9Z"
})));
function SvgImgBannerNiveles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 952 99.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBannerNiveles);
export default __webpack_public_path__ + "static/media/img-banner-niveles.616ca48741b832f804cabbebe72339c2.svg";
export { ForwardRef as ReactComponent };